import colors from "@faire/slate/foundation/color/semantic";

export const buildSlateColorTokens = () => {
  return Object.entries(colors).flatMap(([paletteKey, paletteValue]) => {
    return Object.entries(paletteValue).flatMap(([styleKey, styleValue]) => {
      return Object.entries(styleValue).flatMap(([colorKey, colorValue]) => {
        if (colorValue && typeof colorValue === "object") {
          return Object.entries(colorValue).map(
            ([subColorKey, subColorValue]) => {
              return {
                name: `${paletteKey}.${styleKey}.${colorKey}.${subColorKey}`,
                value: `var(--slate-color-${paletteKey}-${styleKey}-${colorKey}-${subColorKey}, ${subColorValue})`,
              };
            }
          );
        }
        return {
          name: `${paletteKey}.${styleKey}.${colorKey}`,
          value: `var(--slate-color-${paletteKey}-${styleKey}-${colorKey}, ${colorValue})`,
        };
      });
    });
  });
};
